var _rect, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChartIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 9.66675H6V15.6667H9V9.66675Z",
    fill: "#063554"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12.3333H0V15.6666H3V12.3333Z",
    fill: "#063554"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 7H13V15.6667H16V7Z",
    fill: "#063554"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.62627 6.29289L0.91916 7L2.33337 8.41421L3.04048 7.70711L1.62627 6.29289ZM5.66671 3.66667L6.37381 2.95956C6.18628 2.77202 5.93192 2.66667 5.66671 2.66667C5.40149 2.66667 5.14714 2.77202 4.9596 2.95956L5.66671 3.66667ZM8.33337 6.33333L7.62627 7.04044C7.81596 7.23013 8.0739 7.33565 8.34215 7.33329C8.6104 7.33094 8.86646 7.22091 9.05279 7.02792L8.33337 6.33333ZM13.7193 2.19458L14.4139 1.47517L12.975 0.0860045L12.2805 0.805418L13.7193 2.19458ZM3.04048 7.70711L6.37381 4.37377L4.9596 2.95956L1.62627 6.29289L3.04048 7.70711ZM4.9596 4.37377L7.62627 7.04044L9.04048 5.62623L6.37381 2.95956L4.9596 4.37377ZM9.05279 7.02792L13.7193 2.19458L12.2805 0.805418L7.61396 5.63875L9.05279 7.02792Z",
    fill: "#063554"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3334 0H9.33337V2H10.3334V0ZM13.6667 1H14.6667C14.6667 0.447715 14.219 0 13.6667 0V1ZM12.6667 4.33333V5.33333H14.6667V4.33333H12.6667ZM10.3334 2H13.6667V0H10.3334V2ZM12.6667 1V4.33333H14.6667V1H12.6667Z",
    fill: "#063554"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartIcon);
export default __webpack_public_path__ + "static/media/chart-icon.a842d03163b40a310c55092688a406c0.svg";
export { ForwardRef as ReactComponent };